import { render, staticRenderFns } from "./BookableLockingAttributes.vue?vue&type=template&id=704debbe&scoped=true&"
import script from "./BookableLockingAttributes.vue?vue&type=script&lang=js&"
export * from "./BookableLockingAttributes.vue?vue&type=script&lang=js&"
import style0 from "./BookableLockingAttributes.vue?vue&type=style&index=0&id=704debbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704debbe",
  null
  
)

export default component.exports